<template>
  <div :class="$style.container">
    <header>
      <span>编辑设备名称</span>
      <i :class="[$style.fanhui, 'iconfont', 'yw-guanbi1']" @click="$emit('close')"></i>
    </header>
    <main>
      <Field v-model="deviceName" maxlength="10"/>
      <button @click="submit">确定</button>
    </main>
  </div>
</template>
<script>
import { cloudDeviceNameUpdate } from '@/api/suspend';
import { Field } from 'vant';

export default {
  data() {
    return {
      deviceName: '',
    };
  },
  props: ['currentDevice'],
  mounted() {
    this.deviceName = this.currentDevice.custom_name;
  },
  methods: {
    async submit() {
      if (!(/^[\s\S]*.*[^\s][\s\S]*$/).test(this.deviceName)) {
        this.$toast("设备名不能为空");
        return;
      }
      const user_id = this.$getStorage('user_id');
      await cloudDeviceNameUpdate({ 
        custom_name: this.deviceName,
        user_phone_id: this.currentDevice.user_phone_id,
        user_id
      })
      this.$toast('修改成功');
      this.$emit('success', this.deviceName);
    }
  },
  components: {
    Field
  },
};
</script>
<style module lang="scss">
.container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 205px;
  height: 124.5px;
  background: #ffffff;
  border-radius: 5px;
  > header {
    color: #ffffff;
    width: 205px;
    height: 30px;
    background: #ff5b58;
    border-radius: 5px 5px 0px 0px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .fanhui {
      position: absolute;
      right: 10px;
      font-size: 14px;
    }
  }
  > main {
    :global {
      .van-field {
        display: block;
        margin: auto;
        margin-top: 20px;
        width: 155px;
        height: 24px;
        border: 0.5px solid #9b9b9b;
        border-radius: 5px;
        font-size: 14px;
        padding: 0 5px;
      }
    }
    > button {
      display: block;
      border: none;
      outline: none;
      padding: 5px 18px;
      background: #ff5b58;
      border-radius: 14px;
      font-size: 12px;
      text-align: center;
      color: #ffffff;
      margin: auto {
        top: 16px;
      };
    }
  }
}
</style>
